import AdminFeedbackResults from "./AdminFeedbackResults";

export default AdminFeedbackResults;
